<template>
   <div class="contracts-view-v2">
      <ContractsDashboardV2 />
   </div>
</template>

<script>
import ContractsDashboardV2 from '@/components/Contracts/ContractsDashboardV2.vue';

export default {
   name: 'ContractsDashboardViewV2',
   components: {
      ContractsDashboardV2,
   },
}
</script>
